export interface InternalAgentProvenance {
  friendlyLabel: string;
  personaName: string;
  processId?: string;
  processName?: string;
}

const friendlyLabels: Record<string, string> = {
  _system_automatic_process_selector: 'Process selection',
  _system_step_persona_selector: 'Agent selection',
  _system_process_planner: 'Planning',
  _system_goal_evaluator: 'Evaluation',
  _system_explore_decomposer: 'Exploration planning',
  _system_summarizer: 'Context compaction',
  _system_summarizer_reduce: 'Context compaction',
  _system_title_generator: 'Title generation',
  _system_explore: 'Exploration',
  _system_research: 'Research',
  _system_plan: 'Planning',
  _system_evaluate: 'Evaluation',
  _system_audit: 'Audit',
  _system_triage: 'Triage',
  _system_explore_results: 'Exploration results',
};

export function normalizeInternalAgentProvenance(input: {
  personaName?: string;
  processId?: string;
  processName?: string;
}): InternalAgentProvenance | undefined {
  if (!input.personaName?.startsWith('_system_')) return undefined;
  return {
    friendlyLabel: friendlyLabels[input.personaName] ?? 'Internal agent',
    personaName: input.personaName,
    processId: input.processId,
    processName: input.processName,
  };
}
